import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DashedButton from '../DashedButton';
import CheckboxGroup from '../CheckboxGroup';

const ExpandableCheckboxGroup = ({
  buttonLabel,
  dashedButtonProps,
  items,
  limit,
  ...props
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <CheckboxGroup
        inline
        items={items.filter((_, i) => expanded || i < limit)}
        {...props}
      />
      {items.length > limit && !expanded && (
        <div className='mt-2x'>
          <DashedButton
            onClick={() => setExpanded(true)}
            {...dashedButtonProps}
          >
            {buttonLabel}
          </DashedButton>
        </div>
      )}
    </>
  );
};

ExpandableCheckboxGroup.defaultProps = {
  variant: 'fixed'
};

ExpandableCheckboxGroup.propTypes = {
  ...CheckboxGroup.propTypes,
  buttonLabel: PropTypes.string.isRequired,
  dashedButtonProps: PropTypes.shape(DashedButton.propTypes),
  items: PropTypes.array.isRequired,
  limit: PropTypes.number.isRequired,
  variant: CheckboxGroup.propTypes.variant
};

export default ExpandableCheckboxGroup;
